import { useState } from 'react';
import { Navigate, useSearchParams } from 'react-router';
import { authClient, useAuth } from '../lib/auth';

export function LoginPage() {
  const auth = useAuth();
  const [params] = useSearchParams();
  const next = params.get('next') || '/';
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(params.get('error') ? 'Logowanie nie powiodło się.' : null);

  if (auth.status === 'signed-in') return <Navigate to={next} replace />;

  const google = async () => {
    setBusy(true);
    setError(null);
    const { error } = await authClient.signIn.social({ provider: 'google', callbackURL: next, errorCallbackURL: '/login?error=1' });
    if (error) {
      setError(error.message ?? 'Nie udało się rozpocząć logowania przez Google.');
      setBusy(false);
    }
  };

  const magic = async (e: { preventDefault(): void }) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    const { error } = await authClient.signIn.magicLink({ email: email.trim(), callbackURL: next, errorCallbackURL: '/login?error=1' });
    setBusy(false);
    if (error) setError(error.message ?? 'Nie udało się wysłać linku.');
    else setSent(true);
  };

  return (
    <main className="mx-auto flex min-h-dvh max-w-sm flex-col justify-center gap-6 p-6">
      <div className="text-center">
        <img src="/logo.png" alt="" className="mx-auto mb-4 h-20 w-20" />
        <h1 className="text-3xl font-bold">Odhaczka</h1>
        <p className="mt-2 text-stone-600 dark:text-stone-400">Lista zakupów, która zna kolejność alejek w Twoim sklepie.</p>
      </div>

      {!navigator.onLine && (
        <p className="rounded-lg bg-amber-100 p-3 text-sm text-amber-900">Do pierwszego logowania potrzebny jest internet.</p>
      )}

      <button
        onClick={google}
        disabled={busy}
        className="rounded-xl border border-stone-300 bg-white py-3 font-medium shadow-sm active:bg-stone-100 disabled:opacity-50 dark:border-stone-700 dark:bg-stone-900"
      >
        Zaloguj przez Google
      </button>

      <div className="flex items-center gap-3 text-sm text-stone-500">
        <div className="h-px flex-1 bg-stone-300 dark:bg-stone-700" />
        albo
        <div className="h-px flex-1 bg-stone-300 dark:bg-stone-700" />
      </div>

      {sent ? (
        <p className="rounded-lg bg-brand-50 p-4 text-center text-brand-800">
          Wysłaliśmy link na <b>{email}</b>. Otwórz go na tym telefonie.
        </p>
      ) : (
        <form onSubmit={magic} className="flex flex-col gap-3">
          <input
            type="email"
            required
            autoComplete="email"
            placeholder="twój@email.pl"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="rounded-xl border border-stone-300 bg-white px-4 py-3 dark:border-stone-700 dark:bg-stone-900"
          />
          <button disabled={busy} className="rounded-xl bg-brand-700 py-3 font-medium text-white active:bg-brand-800 disabled:opacity-50">
            Wyślij link do logowania
          </button>
        </form>
      )}

      {error && <p className="text-center text-sm text-red-600">{error}</p>}
    </main>
  );
}
